export default __webpack_public_path__ + "static/media/icon-play-optimized.44b8ec8b.svg";